import { BaseService } from "./baseService";
import httpRequest from "./index";
import type { Refund, Page } from "@zhihaoscm/entity";

export class RefundService extends BaseService<unknown, unknown, unknown, unknown> {
    // 收款列表
    public async customPaging(params: unknown): Promise<Page<Refund>> {
        const { data } = await this.service.get(`${this.path}/custom-paging`, { params });
        return data;
    }
}

export const refundService = new RefundService("/refund", httpRequest);
